module.exports = __webpack_public_path__ + "static/img/TJ@3x.82750d62.jpg";